<template>
  <div class="record-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div v-for="item in recordList" :key="item.id">
          <div class="record-item-container">
            <p class="time">{{ formatDateTime(item.createTime) }}</p>
            <div class="info">
              <!-- <div>
                <p>提现金额</p>
                <div class="price">{{ item.cashAmt }}</div>
              </div> -->
              <div>
                <p>礼物名</p>
                <div class="price">{{ item.giftName }}</div>
              </div>
              <div>
                <p>数量</p>
                <div class="price">{{ item.num }}</div>
              </div>
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { giftList } from '@/api/capital';
import { formatDateTime } from '@/utils/index';
const PAGE_SIZE = 10;
export default {
  data() {
    return {
      loading: false,
      finished: false,
      refreshing: false,
      page: { index: 1, size: PAGE_SIZE },
      recordList: [],
    };
  },
  created() {},
  methods: {
    formatDateTime,
    getRecordList(isRefresh) {
      this.loading = true;
      giftList({ page: this.page })
        .then(res => {
          if (isRefresh) {
            this.recordList = res.data.list;
          } else {
            this.recordList = [...this.recordList, ...res.data.list];
          }

          this.page = res.data.next;
          if (res.data.list.length == 0) {
            this.finished = true;
          }
        })
        .finally(() => {
          this.loading = false;
          this.refreshing = false;
        });
    },

    onLoad() {
      this.getRecordList();
    },
    onRefresh() {
      this.page = { index: 1, size: PAGE_SIZE };
      this.finished = false;
      this.getRecordList(true);
    },
  },
};
</script>

<style lang="less" scoped>
.record-container {
  padding: 0px 12px;
  .record-item-container {
    position: relative;
    background-color: white;
    width: 100%;
    box-sizing: border-box;
    margin-top: 10px;
    padding: 11px 20px;
    border-radius: 4px;
    overflow: hidden;
    .time {
      color: #333333;
      font-size: 12px;
    }
    .status {
      position: absolute;
      right: 0;
      top: 0;
      width: 74px;
      height: 28px;
      color: white;
      line-height: 28px;
      text-align: center;
      font-size: 12px;

      border-bottom-left-radius: 14px;
    }
    .succeeded {
      background-color: #409d85;
    }
    .failed {
      background-color: #ff5757;
    }
    .pending {
      background-color: gray;
    }
    .info {
      display: flex;
      justify-content: space-around;
      margin-top: 20px;
      margin-bottom: 8px;
      p {
        color: #666666;
        font-size: 12px;
      }
      .price {
        margin-top: 6px;
        font-size: 18px;
        font-family: DIN-Bold, DIN;
        font-weight: bold;
        color: black;
        line-height: 22px;
      }
    }
  }
}
</style>
